module.exports = __webpack_public_path__ + "static/media/bali.a9b7a5a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/bali.jpg
// module id = 127
// module chunks = 0